import React from 'react'
import { useParams } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import { useAuth } from 'lib/auth'
import Typography from '@material-ui/core/Typography'
import LessonTypeCard from 'components/lesson-type-card'

import useIconAccessor from 'components/lesson-type-category/icons'

const filterLessonsByLocation = (lessonTypes, selectedFacility) =>
  Object.keys(lessonTypes).reduce((acc, cv) => {
    const filteredlessons = lessonTypes[cv].filter(lessonInfo =>
      lessonInfo.locations.some(location =>
        location.id.includes(selectedFacility),
      ),
    )
    acc[cv] = filteredlessons
    return acc
  }, {})

const filterLessonsByActive = (lessonTypes, status) =>
  Object.keys(lessonTypes).reduce((acc, cv) => {
    const filteredlessons = lessonTypes[cv].filter(
      lessonInfo => lessonInfo.status === status,
    )
    acc[cv] = filteredlessons
    return acc
  }, {})

export default ({
  title,
  lessonTypes,
  classes,
  selectedFacility,
  coachName,
  coachExternalId,
  lessonCreditBalances,
  isSingleSession,
  coachIsViewingOwnSchedule,
}) => {
  const { idOrSlug } = useParams()
  const { user } = useAuth()
  const accessor = useIconAccessor()

  const allowedToOverrideInactive =
    user?.coach?.externalId === idOrSlug ||
    user?.coach?.coachProfile?.slug === idOrSlug

  lessonTypes = allowedToOverrideInactive
    ? lessonTypes
    : filterLessonsByActive(lessonTypes, 'ACTIVE')

  const filteredLessonTypes =
    selectedFacility !== 'all'
      ? filterLessonsByLocation(lessonTypes, selectedFacility)
      : lessonTypes

  return Object.keys(filteredLessonTypes).map((category, i) =>
    filteredLessonTypes[category].length ? (
      <div key={i} style={{ margin: '40px 0 48px' }}>
        {i === 0 && (
          <Typography
            variant="h5"
            style={{ marginBottom: '20px', fontWeight: '500' }}
          >
            {title}
          </Typography>
        )}
        <Typography className={classes.sectionTitle} variant="h6">
          {accessor[category].text}
        </Typography>
        <Grid container spacing={2}>
          {filteredLessonTypes[category].map(lessonInfo => (
            <Grid
              key={lessonInfo.id}
              item
              md={6}
              sm={12}
              style={{ width: '100%' }}
            >
              <LessonTypeCard
                lessonInfo={lessonInfo}
                bookingUrl={`/coach/${idOrSlug}/schedule?lessonTypeId=${lessonInfo.id}&locationId=${lessonInfo.locationId}`}
                shouldBeClickable
                coachName={coachName}
                coachExternalId={coachExternalId}
                isSingleSession={isSingleSession}
                lessonCreditBalance={lessonCreditBalances?.filter(
                  lcb => lcb.lessonType.id === lessonInfo.id,
                )}
                coachIsViewingOwnSchedule={coachIsViewingOwnSchedule}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    ) : null,
  )
}
